import React, { type ReactElement } from 'react';

import { Hint, type HintProps } from '../Hint';

interface RedesignOnboardingHintProps {
	open: boolean;
	children: ReactElement;
	title: string;
	description: string | ReactElement;
	placement: HintProps['placement'];
	onClose: () => void;
	isNew?: boolean;
}

const RedesignOnboardingHint = ({
	open,
	children,
	title,
	description,
	placement,
	onClose,
	isNew,
}: RedesignOnboardingHintProps) => (
	<Hint
		title={title}
		description={description}
		open={open}
		onClose={onClose}
		offset={{ x: 0 }}
		placement={placement}
		disablePortal={false}
		useDesktopButtonDesign={true}
		isNew={isNew}
	>
		{children}
	</Hint>
);

export default RedesignOnboardingHint;
